import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IDurchsuchenResponseRow } from 'fa-kt.types';
import { BehaviorSubject } from 'rxjs';
import { DurchsuchenService } from '../service';

@Component({
  selector: 'fa-kt-durchsuchen-list',
  templateUrl: './durchsuchen-list.component.html',
  styleUrls: ['./durchsuchen-list.component.css'],
})
export class DurchsuchenListComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  @Output() select: EventEmitter<string> = new EventEmitter<string>();

  constructor(public durchsuchen: DurchsuchenService) {}

  public set(durchsuchen: IDurchsuchenResponseRow) {}
}
